import { render, staticRenderFns } from "./DeleteEmployeeComponent.vue?vue&type=template&id=c79347d8&"
import script from "./DeleteEmployeeComponent.vue?vue&type=script&lang=js&"
export * from "./DeleteEmployeeComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports